import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-template-l" }
const _hoisted_2 = { class: "p-the-template-l__inner" }
const _hoisted_3 = { class: "p-the-template-l__header" }
const _hoisted_4 = { class: "p-the-template-l__body" }
const _hoisted_5 = {
  key: 0,
  class: "p-the-template-l__body__header"
}
const _hoisted_6 = {
  key: 1,
  class: "p-the-template-l__right-col"
}
const _hoisted_7 = {
  key: 0,
  class: "p-the-template-l__shown-search-form-button"
}
const _hoisted_8 = {
  key: 1,
  class: "p-the-template-l__sorted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_FormSearch = _resolveComponent("FormSearch")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_ButtonRefineBase = _resolveComponent("ButtonRefineBase")!
  const _component_ButtonRefine = _resolveComponent("ButtonRefine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheBreadcrumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          (_ctx.heading)
            ? (_openBlock(), _createBlock(_component_CommonHeading, {
                key: 0,
                "block-large-sp": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.heading), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (
            _ctx.indicateSearchForm || _ctx.indicateSearchButton || _ctx.indicateSortedButton
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.indicateSearchForm)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref: "searchFormElement",
                    class: _normalizeClass(["p-the-template-l__search", _ctx.executeSearchFormDomAnimation ? _ctx.searchFormClassName : '']),
                    style: _normalizeStyle(_ctx.isSmartPhone ? _ctx.serchFormStyle : {})
                  }, [
                    _createVNode(_component_FormSearch, {
                      search: _ctx.search,
                      "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                      placeholder: _ctx.searchPlaceholder,
                      onDoSearch: _ctx.doSearch
                    }, null, 8, ["search", "placeholder", "onDoSearch"]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.error), 1)
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.error]
                      ])
                    ])
                  ], 6))
                : _createCommentVNode("", true),
              (_ctx.indicateSearchButton || _ctx.indicateSortedButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_ctx.indicateSearchButton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("button", {
                            class: "p-the-template-l__shown-search-form-button__button",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchSearchFormState && _ctx.switchSearchFormState(...args)))
                          }, [
                            _createVNode(_component_ButtonRefineBase, null, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("検索", -1)
                              ])),
                              _: 1,
                              __: [4]
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.indicateSortedButton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_ButtonRefine, {
                            refine: _ctx.sorted.target,
                            "onUpdate:refine": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sorted.target) = $event)),
                            heading: _ctx.filterHeading,
                            icon: "arrow",
                            "icon-color": "#bdbdbd",
                            "refine-item-list": _ctx.sorted.itemList,
                            shown: _ctx.sorted.shownState,
                            onDoSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doSort($event))),
                            onSwitchRefineState: _ctx.switchSortedState
                          }, null, 8, ["refine", "heading", "refine-item-list", "shown", "onSwitchRefineState"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          ref: "contentElement",
          class: "p-the-template-l__body__content",
          style: _normalizeStyle(_ctx.contentElementStyle)
        }, [
          _renderSlot(_ctx.$slots, "contents", {}, undefined, true)
        ], 4)
      ])
    ])
  ]))
}